import MemoryOperation from "../enum/MemoryOperation";
import { getHandlerForMemoryType } from "../factory/MemoryFactory";

let memoryInstance;

class Memory {
  constructor() {
    if (memoryInstance) {
      // checks if instance of this class exists or not. If exists, then do not create new instance, simply return.
      return;
    }
    memoryInstance = this;
  }

  handleRequest(operation, memoryType, data) {
    const handler = getHandlerForMemoryType(memoryType);
    if (operation === MemoryOperation.READ) {
      return handler.read(data["key"]);
    } else if (operation === MemoryOperation.WRITE) {
      return handler.write(data["key"], data["value"]);
    }
  }
}

export default Memory;
